export const getAuthPath = (auth: string) => {
    return `${auth}/oauth2/v2.0/token?p=b2c_1a_ropc_auth`;
};
